import React from 'react';

import { UnfinishedTestCaseExecutionsTableRowProps } from '@qality/common-components/src/gadgets/UnfinishedTestCaseExecutions';
import {
  Pagination as IPagination,
  ReportFetchResult,
  User,
} from '@qality/common-model';

export interface DashboardContextProps {
  isQAlityConfigured: boolean;
  isProjectAdmin: boolean;
  projectKey: string;
  projectId: string;
  user: User;
  isOnboardingGadgetOpened: boolean;
  openOnboardingGadget: () => void;
  closeOnboardingGadget: () => void;
  testCaseExecutionReport: ReportFetchResult;
  showAssignedToMeOnly: boolean;
  unfinishedTestCaseExecutions: UnfinishedTestCaseExecutionsTableRowProps[];
  pagination: IPagination | undefined;
  isLoading: boolean;
  handlePageChange: (event: any, newPage: number) => void;
  toggleShowAssignedToMeOnly: () => void;
  isLoadingUnfinishedTestCaseExecutions: boolean;
}

const initialValues: DashboardContextProps = {
  isQAlityConfigured: false,
  isProjectAdmin: false,
  projectKey: null,
  projectId: null,
  user: null,
  isOnboardingGadgetOpened: false,
  openOnboardingGadget: () => undefined,
  closeOnboardingGadget: () => undefined,
  testCaseExecutionReport: null,
  showAssignedToMeOnly: undefined,
  unfinishedTestCaseExecutions: [],
  pagination: undefined,
  isLoading: true,
  handlePageChange: () => undefined,
  toggleShowAssignedToMeOnly: () => undefined,
  isLoadingUnfinishedTestCaseExecutions: true,
};

export const DashboardContext =
  React.createContext<DashboardContextProps>(initialValues);
